/**
 * Date utility functions for Unix timestamp conversion
 * Backend API uses Unix timestamps in seconds (not milliseconds)
 */

/**
 * Convert ISO date string (YYYY-MM-DD) to Unix timestamp in seconds
 * @param isoDate - ISO format date string (e.g., "2026-02-12")
 * @returns Unix timestamp in seconds, or 0 if invalid date
 */
export function toUnixTimestamp(isoDate: string | null | undefined): number {
  if (!isoDate || isoDate.trim() === '') {
    return 0;
  }

  try {
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
      return 0;
    }
    // Convert milliseconds to seconds
    return Math.floor(date.getTime() / 1000);
  } catch {
    return 0;
  }
}

/**
 * Convert Unix timestamp (seconds) to ISO date string (YYYY-MM-DD)
 * @param timestamp - Unix timestamp in seconds
 * @returns ISO format date string (YYYY-MM-DD), or empty string if invalid
 */
export function fromUnixTimestamp(timestamp: number | null | undefined): string {
  if (!timestamp || timestamp === 0) {
    return '';
  }

  try {
    // Convert seconds to milliseconds
    const date = new Date(timestamp * 1000);
    if (isNaN(date.getTime())) {
      return '';
    }
    // Format as YYYY-MM-DD
    return date.toISOString().split('T')[0];
  } catch {
    return '';
  }
}
